import { render, staticRenderFns } from "./distributionOrder.vue?vue&type=template&id=051a6e24&scoped=true"
import script from "./distributionOrder.vue?vue&type=script&lang=js"
export * from "./distributionOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a6e24",
  null
  
)

export default component.exports